import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { FAVORITES } from "@/libs/apis/onboarding/reactQueryCacheKeys";
import { makeApiGetUserFavoritesCall } from "@/src/services/api/favorites/getUserFavorites";

export type PostUserFavorites = {
  chainId: number;
  contractAddress: string;
  tokenIds: string[];
  swooshHandle: string;
  keys?: string[];
};

type UserFavoritesType = {
  [tokenId: string]: boolean;
};

const useUserFavoriteTokens = ({
  chainId,
  contractAddress,
  swooshHandle,
  tokenIds,
  keys = [swooshHandle, FAVORITES],
}: PostUserFavorites) => {
  const { isLoading, error, data } = useQuery<
    UserFavoritesType,
    AxiosError,
    UserFavoritesType
  >(
    keys,
    async () =>
      await makeApiGetUserFavoritesCall(
        chainId,
        contractAddress,
        swooshHandle,
        tokenIds,
      ),
    {
      enabled: !!tokenIds && !!chainId && !!contractAddress && !!swooshHandle,
    },
  );

  return {
    isLoading,
    error,
    data,
  };
};

export default useUserFavoriteTokens;
